import { createContext, useContext, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useFeatureFlag } from 'context/featureFlagContext';
import { getSubscriptionToken } from 'services/billing';
import { useHttp } from 'context/httpContext';
import { CompanyActions } from 'store/reducers/company';

let SubscriptionContext = createContext({
	hasSubscription: false,
	loading: true,
});

const useSubscription = () => useContext(SubscriptionContext);

function SubscriptionProvider({ children }) {
	const dispatch = useDispatch();
	const { subscriptionEnabled, subscriptionTokenEnabled, loading: featureFlagsLoading } = useFeatureFlag();
	const { httpServiceInstance } = useHttp();
	const tokenPromise = useRef(null);

	const { currentCompany, loading: companyLoading } = useSelector((state) => state.company);

	const hasSubscription = subscriptionEnabled ? currentCompany?.hasSubscription || false : true;

	useEffect(() => {
		if (!subscriptionTokenEnabled) return;

		tokenPromise.current = new Promise(async (resolve) => {
			try {
				getSubscriptionToken(currentCompany || {}).then((token) => {
					httpServiceInstance.setSubscriptionToken(token);
					dispatch(CompanyActions.tokenHasChanged());
					resolve(token);
				});
			} catch (e) {
				resolve(null);
			}
		});
	}, [currentCompany]);

	const value = {
		hasSubscription,
		loading: featureFlagsLoading || companyLoading || (currentCompany && !Object.hasOwn(currentCompany, 'hasSubscription')),
		tokenPromise: tokenPromise.current,
	};

	return <SubscriptionContext.Provider value={value}>{children}</SubscriptionContext.Provider>;
}

export { useSubscription, SubscriptionProvider };
